export default {
  default: {
    user: {
      validateLinkingSignature: false,
      allowChangeLinkingEmail: false
    }
  },
  validator() {},
};
